<div *ngIf="show_popup" class="fixed inset-0 z-[9999] flex items-center justify-center">

  <!-- Backdrop -->
  <div class="absolute inset-0 bg-gradient-to-br from-indigo-900/30 to-slate-900/40 backdrop-blur-[6px]"></div>

  <!-- Card -->
  <div class="relative bg-white/90 backdrop-blur-xl rounded-3xl shadow-[0_32px_80px_rgba(63,65,209,0.18)] px-10 py-10 flex flex-col items-center w-[400px] border border-white">

    <!-- Icon badge -->
    <div class="w-12 h-12 rounded-2xl bg-indigo-50 flex items-center justify-center mb-5">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3F41D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    </div>

    <!-- Title -->
    <h2 class="text-[22px] font-bold text-[#101828] text-center leading-snug mb-1">Session Expiring Soon</h2>
    <p class="text-sm text-gray-400 text-center mb-7">You've been inactive. Your session will expire in</p>

    <!-- Circular countdown -->
    <div class="relative w-[160px] h-[160px] flex items-center justify-center mb-8">
      <svg class="absolute top-0 left-0 w-full h-full -rotate-90" viewBox="0 0 160 160">
        <circle cx="80" cy="80" r="68" fill="none" stroke="#EEF0FF" stroke-width="8" />
        <circle cx="80" cy="80" r="68" fill="none" stroke="url(#grad)" stroke-width="8" stroke-linecap="round" [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="stroke_dashoffset" style="transition: stroke-dashoffset 1s linear;" />
        <defs>
          <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#6366f1" />
            <stop offset="100%" stop-color="#3F41D1" />
          </linearGradient>
        </defs>
      </svg>
      <div class="flex flex-col items-center z-10">
        <span class="text-4xl font-bold text-[#101828] tracking-tight leading-none">
          {{ display_minutes }}:{{ display_seconds }}
        </span>
        <span class="text-[11px] text-gray-400 mt-1.5 tracking-widest uppercase">remaining</span>
      </div>
    </div>

    <!-- Resume button -->
    <button (click)="resume()" class="w-full flex items-center justify-center gap-2 bg-[#3F41D1] hover:bg-indigo-700 active:scale-[0.98] text-white text-base font-semibold py-3.5 rounded-2xl transition-all shadow-[0_4px_16px_rgba(63,65,209,0.35)]">
      <svg width="16" height="16" viewBox="0 0 18 18" fill="white">
        <polygon points="4,2 16,9 4,16" />
      </svg>
      Resume Session
    </button>

    <!-- Subtext -->
    <p class="text-xs text-gray-400 mt-4 text-center">Move your mouse or press any key to stay logged in</p>

  </div>
</div>